module.exports = __webpack_public_path__ + "media/images/logo-wordmark-dark-8c16d81ed8d210110ba8e1c786fc6a1b.svg";